// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "dirty": false,
    "raw": "8b64654",
    "hash": "8b64654",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "8b64654",
    "semverString": null,
    "version": "1.4.0"
};
